import { HTTPAPI } from "../base";

const grabToken = () => {
    const uInfoTxt = localStorage.getItem("userInfo");    
    let uInfo = null;
    if(uInfoTxt) {
        uInfo = JSON.parse(uInfoTxt);
    }
    const token = uInfo != null ? uInfo.token : "";
    return token;
}

const devicetype = {
    getList: (urlCriteria) => {        
        return HTTPAPI(grabToken())
        .get("/devicetype/list" + urlCriteria)
    },
    getAll: () => {        
        return HTTPAPI(grabToken())
        .get("/devicetype")
    },
    delete: (code) => {        
        return HTTPAPI(grabToken())
        .delete("/devicetype/" + code)
    },
    getOne: (code) => {        
        return HTTPAPI(grabToken())
        .get("/devicetype/" + code)
    },
    update: (code, data) => {
        return HTTPAPI(grabToken())
        .patch("/devicetype/" + code, data);
    },
    create: (data) => {
        return HTTPAPI(grabToken())
        .post("/devicetype/", data);
    },
}

export default devicetype;
